// Les documents du back stockent leurs traductions dans des champs suffixés par le code
// ISO de la langue (name_fr, business_name_ar, ...). Les codes i18n de l'app ne collent pas
// tous à ces suffixes ('esp' -> 'es', 'port' -> 'pt'), d'où cette table de correspondance.
const LOCALE_SUFFIXES = {
  en: 'en',
  fr: 'fr',
  ar: 'ar',
  de: 'de',
  esp: 'es',
  es: 'es',
  port: 'pt',
  pt: 'pt'
};

export const getLocaleSuffix = (language) => {
  // LanguageDetector peut renvoyer une variante régionale ('fr-FR'), on ne garde que la base.
  const base = (language || '').toLowerCase().split('-')[0];
  return LOCALE_SUFFIXES[base] || 'en';
};

// Locale BCP 47 pour Intl / toLocale*String : les codes 'esp' et 'port' de l'app ne sont pas
// valides ('port' fait même lever une RangeError), d'où le passage par le suffixe ISO.
export const getIntlLocale = (language) => getLocaleSuffix(language);

// La reconnaissance vocale du navigateur attend une variante régionale.
const SPEECH_LOCALES = {
  en: 'en-GB',
  fr: 'fr-FR',
  ar: 'ar-SA',
  de: 'de-DE',
  es: 'es-ES',
  pt: 'pt-PT'
};

export const getSpeechLocale = (language) => SPEECH_LOCALES[getLocaleSuffix(language)];

/**
 * Renvoie la valeur traduite d'un champ, avec repli sur l'anglais puis sur le champ de base.
 * ex: getLocalizedName(area, 'business_name', 'ar') -> business_name_ar || business_name_en || business_name
 */
export const getLocalizedName = (doc, baseField, language) => {
  if (!doc) return '';
  const suffix = getLocaleSuffix(language);
  return (
    doc[`${baseField}_${suffix}`] ||
    doc[`${baseField}_en`] ||
    doc[baseField] ||
    ''
  );
};

export default getLocalizedName;
